var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCardAmex = function SvgCardAmex(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "card-amex_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 40 40"
    }
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".card-amex_svg__st2{fill:#fff}")), /*#__PURE__*/React.createElement("path", {
    d: "M4 7h32a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V11a4 4 0 0 1 4-4z",
    style: {
      fill: "#016fd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.941 17.621c0-.053.014-.106.042-.151l.461-.768a.293.293 0 0 1 .252-.143h2.088c.162 0 .294.132.294.294v4.118a.294.294 0 0 1-.294.294H3.696a.293.293 0 0 1-.252-.143l-.461-.768a.299.299 0 0 1-.042-.151v-2.582zm3.53-.768c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255-.294a.294.294 0 0 0-.294.294v2.157c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 19.01v-2.157a.294.294 0 0 0-.294-.294h-.98zm-2.255 2.843c0-.162.132-.294.294-.294h.98c.162 0 .294.132.294.294v1.569a.294.294 0 0 1-.294.294h-.98a.294.294 0 0 1-.294-.294v-1.569zm2.255.294a.294.294 0 0 0-.294.294v.98c0 .162.132.294.294.294h.98A.294.294 0 0 0 10 20.97v-.98a.294.294 0 0 0-.294-.294h-.98z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#0185ff"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__st2",
    d: "M37.993 17.025h-.974l-.816-.895-.807.895h-3.347v-2.796H35.423l.802.886.804-.886h.964v-.392l-.734.006v-1.919l-.699 1.913h-.676l-.714-1.92v1.92h-.741.001-.872l-.234-.559h-1.269l-.233.559h-.851l1.24-2.793h.983l1.224 2.767v-2.768l1.196.004.615 1.718.62-1.722h1.144v-.389h-1.442l-.328.919-.327-.919h-1.898v1.226l-.54-1.226h-1.537l-1.579 3.583h1.281v3.181l3.954.008.621-.693.626.69h1.169z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "card-amex_svg__st2",
    d: "M37.993 16.978v-.573l-.73-.787.73-.78v-.579l-1.276 1.366zM35.72 15.625l-1.3-1.384v.632h-1.603v.437h1.565v.633h-1.565v.43h1.603v.64zM33.062 12.651l-.372-.89-.372.89z"
  })));
};
export default SvgCardAmex;